import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
Vue.config.productionTip = false


import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueToast, {
  position: localStorage.getItem('dmlang') == 'ar' ? 'bottom-left' : 'bottom-right'
})

import {i18n} from '@/i18n'


import utils from '@/utils/utils.js'
const plugin = {
  install () {
    Vue.utils = utils
    Vue.prototype.$utils = utils
  }
}
Vue.use(plugin)

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')